<template>
  <button class="i_btn">立即购买</button>
</template>

<script>
export default {
  data() {
    return {

    };
  },
  components: {

  }
};
</script>

<style scoped lang="stylus">
@import '~@/assets/styles/var.styl';
.i_btn {
  width 140px
  line-height 40px
  color $white
  font-size $fontSizeBig
  background-color $fontColorLight
  border-radius 25px
  border none
}
</style>
